const { APP_DOMAIN } = require('../data/constants/app')

module.exports = {
    hosts: `https://app.${APP_DOMAIN} https://raindrop.onfastspring.com`
}